import React from 'react';
import './Testimonials.css';

function Testimonials() {
  const testimonials = [
    {
      id: 1,
      stars: 5,
      text: "As a professional within the health care setting, I've found my interactions with YesTherapy deeply compassionate and empathetic but also skilled at keeping me focused and encouraging me to face challenging issues head-on.",
      name: "Lynn",
      role: "December 2024"
    },
    {
      id: 2,
      stars: 5,
      text: "It really helped me. I have ADHD and I just couldn't start a task. And chatgpt was rubbish. I got a good & realistic planning. I got tips on how to work (I had let a lot of time go, because I just couldn't start - adhd thing).",
      name: "Reddit user",
      role: "January 2025"
    },
    {
      id: 3,
      stars: 4,
      text: "At first, I was skeptical about talking to an AI, but it quickly became a surprisingly comforting part of my routine. The feedback helps me reflect without pressure. I love how I can check in anytime, especially when I'm feeling anxious late at night.",
      name: "Beta user",
      role: "March 2025"
    }
  ];

  const renderStars = (count) => {
    return [...Array(count)].map((_, index) => (
      <span key={index} className="star">★</span>
    ));
  };

  return (
    <section className="testimonials-section">
      <div className="container">
        <h2>Our happy users say</h2>

        <div className="testimonials-grid">
          {testimonials.map((testimonial) => (
            <div key={testimonial.id} className="testimonial-card">
              <div className="stars">
                {renderStars(testimonial.stars)}
              </div>

              <p className="testimonial-text">{testimonial.text}</p>

              <div className="divider"></div>

              <div className="testimonial-author">
                <div className="author-avatar"></div>
                <div className="author-info">
                  <h4>{testimonial.name}</h4>
                  <p>{testimonial.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Testimonials; 